import React from 'react';
import { useSelector } from 'react-redux';
import styles from '../OptionsBoardStyles';
import {
  Modal,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TableSortLabel,
} from '@material-ui/core';
import premium from '../../icons/Volume.png';
import premiumMobile from '../../icons/volumemobile.png';
import {
  formatIV,
  formatPercent,
  formatVWAP,
} from '../../../utils/numberFormatFunc';
import { Bar } from 'react-chartjs-2';
import BasicCallBoardModalDesktop from './BasicCallBoardModalDesktop';
import { plugins } from '../chartConfig';
import BasicCallBoardModalMobile from './BasicCallBoardModalMobile';

const VolumeModal = (props) => {
  const {
    localOD,
    state,
    sortData,
    chartData,
    chartOptionsMobile,
    chartOptions,
    barData,
    toggleModal,
    keyName,
  } = props;
  const { showModal, orderBy, order } = state;

  const { appReducer } = useSelector((state) => state);
  const { accessLevel, isMobile } = appReducer;
  const cellStyles = { ...styles.modalTableRow, padding: 0 };

  const barOptions = {
    maintainAspectRatio: false,
    responsive: true,
    tooltips: {
      mode: 'label',
    },
    legend: {
      display: false,
    },
    layout: {
      padding: {
        left: 5,
        right: 5,
        top: 5,
        bottom: 5,
      },
    },
    elements: {
      line: {
        fill: false,
      },
    },
  };

  return (
    <Modal
      aria-labelledby="simple-modal-title"
      aria-describedby="simple-modal-description"
      open={showModal}
      onClose={toggleModal}
    >
      <div
        style={
          isMobile ? styles.boardModalContentMobile : styles.boardModalContent
        }
      >
        <div
          onClick={() => toggleModal()}
          style={
            !isMobile ? styles.modalCloseButton : styles.modalCloseButtonMobile
          }
        >
          X
        </div>

        <BasicCallBoardModalDesktop state={state} keyName={keyName} />
        <BasicCallBoardModalMobile state={state} keyName={keyName} />
        {accessLevel === 'halfaccess' ? (
          <div style={styles.premiumdiv}>
            {' '}
            <div>
              <img
                height="100%"
                width="100%"
                src={isMobile ? premiumMobile : premium}
                alt=""
              />
            </div>
          </div>
        ) : (
          <div>
            <div
              style={
                isMobile
                  ? styles.boardModalBigGraphMobile
                  : styles.boardModalBigGraphCallPage
              }
            >
              <Bar
                height={isMobile ? 200 : 100}
                data={chartData}
                options={isMobile ? chartOptionsMobile : chartOptions}
                plugins={plugins}
              />
            </div>
            <div
              style={
                isMobile
                  ? styles.boardModalSmallGraphMobile
                  : styles.boardModalSmallGraphCallpage
              }
            >
              <Bar data={barData} options={barOptions} />
            </div>
            <div style={{ ...styles.boardModalTableContainer, width: '100%' }}>
              <Table>
                <TableHead>
                  <TableRow style={styles.tableRow}>
                    <TableCell
                      style={{ ...styles.modalTableHeaderCell, padding: 0 }}
                      className="sticky"
                      align="right"
                    >
                      <TableSortLabel
                        style={{ color: '#Fff' }}
                        active={orderBy === 'time'}
                        direction={orderBy === 'time' ? order : 'asc'}
                        onClick={() => sortData('time')}
                      >
                        Time
                      </TableSortLabel>
                    </TableCell>
                    <TableCell
                      style={{ ...styles.modalTableHeaderCell, padding: 0 }}
                      className="sticky"
                      align="right"
                    >
                      <TableSortLabel
                        style={{ color: '#Fff' }}
                        active={orderBy === 'volume'}
                        direction={orderBy === 'volume' ? order : 'asc'}
                        onClick={() => sortData('volume')}
                      >
                        {isMobile ? 'Vol' : 'Volume'}
                      </TableSortLabel>
                    </TableCell>
                    <TableCell
                      style={{ ...styles.modalTableHeaderCell, padding: 0 }}
                      className="sticky"
                      align="right"
                    >
                      <TableSortLabel
                        style={{ color: '#Fff' }}
                        active={orderBy === 'vwap'}
                        direction={orderBy === 'vwap' ? order : 'asc'}
                        onClick={() => sortData('vwap')}
                      >
                        {isMobile ? 'Prem' : 'Premium'}
                      </TableSortLabel>
                    </TableCell>
                    {!isMobile && (
                      <TableCell
                        style={styles.modalTableHeaderCell}
                        className="sticky"
                        align="right"
                      >
                        <TableSortLabel
                          style={{ color: '#Fff' }}
                          active={orderBy === 'bidside'}
                          direction={orderBy === 'bidside' ? order : 'asc'}
                          onClick={() => sortData('bidside')}
                        >
                          Bid%
                        </TableSortLabel>
                      </TableCell>
                    )}
                    {!isMobile && (
                      <TableCell
                        style={styles.modalTableHeaderCell}
                        className="sticky"
                        align="right"
                      >
                        <TableSortLabel
                          style={{ color: '#Fff' }}
                          active={orderBy === 'askside'}
                          direction={orderBy === 'askside' ? order : 'asc'}
                          onClick={() => sortData('askside')}
                        >
                          Ask%
                        </TableSortLabel>
                      </TableCell>
                    )}
                    <TableCell
                      style={{ ...styles.modalTableHeaderCell, padding: 0 }}
                      className="sticky"
                      align="right"
                    >
                      <TableSortLabel
                        style={{ color: '#Fff' }}
                        active={orderBy === 'spot'}
                        direction={orderBy === 'spot' ? order : 'asc'}
                        onClick={() => sortData('spot')}
                      >
                        {isMobile ? 'Stk' : 'StkRef'}
                      </TableSortLabel>
                    </TableCell>
                    <TableCell
                      style={{ ...styles.modalTableHeaderCell, padding: 0 }}
                      className="sticky"
                      align="right"
                    >
                      <TableSortLabel
                        style={{ color: '#Fff' }}
                        active={orderBy === 'ivol'}
                        direction={orderBy === 'ivol' ? order : 'asc'}
                        onClick={() => sortData('ivol')}
                      >
                        IV
                      </TableSortLabel>
                    </TableCell>
                    <TableCell
                      style={{
                        ...styles.modalTableHeaderCell,
                        padding: 0,
                        width: '30px',
                      }}
                      className="sticky"
                      align="right"
                    >
                      <TableSortLabel
                        style={{ color: '#Fff' }}
                        active={orderBy === 'complex'}
                        direction={orderBy === 'complex' ? order : 'asc'}
                        onClick={() => sortData('complex')}
                      >
                        {isMobile ? 'Sprd' : 'Spreads'}
                      </TableSortLabel>
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {localOD
                    .sort((a, b) => {
                      if (
                        !orderBy ||
                        !(
                          typeof a[orderBy] === 'number' ||
                          typeof a[orderBy] === 'string'
                        )
                      )
                        return 0;
                      if (orderBy === 'bidside' || orderBy === 'askside') {
                        return order === 'desc'
                          ? a[orderBy] / a['volume'] - b[orderBy] / b['volume']
                          : b[orderBy] / b['volume'] - a[orderBy] / a['volume'];
                      } else {
                        if (typeof a[orderBy] === 'number')
                          return order === 'desc'
                            ? a[orderBy] - b[orderBy]
                            : b[orderBy] - a[orderBy];
                        else {
                          return order === 'desc'
                            ? a[orderBy].localeCompare(b[orderBy])
                            : b[orderBy].localeCompare(a[orderBy]);
                        }
                      }
                    })
                    .map((row) => (
                      <TableRow style={{ height: '5px' }} key={row.time}>
                        <TableCell style={cellStyles} align="center">
                          {row.time}
                        </TableCell>
                        <TableCell style={cellStyles} align="center">
                          {row.volume}
                        </TableCell>
                        <TableCell style={cellStyles} align="center">
                          ${formatVWAP(row.vwap)}
                        </TableCell>
                        {!isMobile && (
                          <TableCell
                            style={{
                              ...styles.modalTableRowGray,
                              padding: 0,
                            }}
                            align="right"
                          >
                            {formatPercent(row.bidside / row.volume)}%
                          </TableCell>
                        )}
                        {!isMobile && (
                          <TableCell
                            style={{
                              ...styles.modalTableRowGray,
                              padding: 0,
                            }}
                            align="right"
                          >
                            {formatPercent(row.askside / row.volume)}%
                          </TableCell>
                        )}
                        <TableCell style={cellStyles} align="center">
                          ${formatVWAP(row.spot)}
                        </TableCell>
                        <TableCell
                          style={{
                            ...styles.modalTableRowYellow,
                            padding: 0,
                          }}
                          align="center"
                        >
                          {formatIV(row.ivol)}
                        </TableCell>
                        <TableCell
                          style={{
                            ...styles.modalTableRow,
                            padding: 0,
                            width: '30px',
                          }}
                          align="center"
                        >
                          {row.complex}
                        </TableCell>
                      </TableRow>
                    ))}
                </TableBody>
              </Table>
            </div>
          </div>
        )}
      </div>
    </Modal>
  );
};

export default VolumeModal;



// WEBPACK FOOTER //
// ./src/Pages/OptionsBoard/BasicCallBoard/VolumeModal.jsx